// LLM-facing major-unit strings — not for UI; use the locale-aware `formatNumber` there
export const centsToMajor = (cents) => (cents / 100).toFixed(2);
export const centsStringToMajor = (cents) => centsToMajor(Number(cents));
// Round, don't truncate: 19.99 * 100 is 1998.9999999999998 in float.
export const majorToCents = (major) => Math.round(major * 100);
//# sourceMappingURL=money.js.map